import Vue from 'vue';
import Router from 'vue-router';
import Home from '../components/Home.vue'
import Virtual from '../components/Virtual.vue'
import Web from '../components/Web.vue'
import System from '../components/System.vue'
import Cases from '../components/Cases.vue'
import Pricing from '../components/Pricing.vue'
import Contact from '../components/Contact.vue'

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '*',
            redirect: '/Home'
        },
        {
            path: '/Home',
            name: 'Home',
            component: Home
        },
        {
            path: '/Virtual',
            name: 'Virtual',
            component: Virtual
        },
        {
            path: '/Web',
            name: 'Web',
            component: Web
        },
        {
            path: '/System',
            name: 'System',
            component: System
        },
        {
            path: '/Cases',
            name: 'Cases',
            component: Cases
        },
        {
            path: '/Pricing',
            name: 'Pricing',
            component: Pricing
        },
        {
            path: '/Contact',
            name: 'Contact',
            component: Contact
        },
    ],
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
      }
});


// WEBPACK FOOTER //
// ./src/router/index.js